import { render, staticRenderFns } from "./OpcionList.vue?vue&type=template&id=10503142&scoped=true&"
import script from "./OpcionList.vue?vue&type=script&lang=js&"
export * from "./OpcionList.vue?vue&type=script&lang=js&"
import style0 from "./OpcionList.vue?vue&type=style&index=0&id=10503142&lang=scss&scoped=true&"
import style1 from "./OpcionList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10503142",
  null
  
)

export default component.exports